/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import Login from '../components/feature/account/Login';
import AddToCoverForm from '../components/feature/addtocoverform/AddToCoverForm';
import DiscardModal from '../components/feature/addtocoverform/steps/shared/DiscardModal';
import OptionalBenefits from '../components/feature/addtocoverform/steps/shared/OptionalBenefits';
import RacqCheckBox from '../components/feature/addtocoverform/steps/shared/RacqCheckBox';
import SummaryTable from '../components/feature/addtocoverform/steps/shared/SummaryTable';
import Step1AddToCoverForm from '../components/feature/addtocoverform/steps/Step1AddToCoverForm';
import Step2AddToCoverForm from '../components/feature/addtocoverform/steps/Step2AddToCoverForm';
import Step3AddToCoverForm from '../components/feature/addtocoverform/steps/Step3AddToCoverForm';
import PageAnalyticsData from '../components/feature/analytics/PageAnalyticsData';
import CallBackForm from '../components/feature/callBackForm/CallBackForm';
import Step1CallBackForm from '../components/feature/callBackForm/steps/Step1CallBackForm';
import Step2CallBackForm from '../components/feature/callBackForm/steps/Step2CallBackForm';
import CancelInsuranceForm from '../components/feature/cancelinsuranceform/CancelInsuranceForm';
import ChangeVehicleTileInsurance from '../components/feature/cancelinsuranceform/steps/shared/ChangeVehicleTileInsurance';
import Step1CancelInsurance from '../components/feature/cancelinsuranceform/steps/Step1CancelInsurance';
import Step2CancelInsurance from '../components/feature/cancelinsuranceform/steps/Step2CancelInsurance';
import Step3CancelInsurance from '../components/feature/cancelinsuranceform/steps/Step3CancelInsurance';
import Step4CancelInsurance from '../components/feature/cancelinsuranceform/steps/Step4CancelInsurance';
import Step5CancelInsurance from '../components/feature/cancelinsuranceform/steps/Step5CancelInsurance';
import CancelRoadsideForm from '../components/feature/cancelroadsideform/CancelRoadsideForm';
import ChangeVehicleTile from '../components/feature/cancelroadsideform/steps/shared/ChangeVehicleTile';
import ProductDetailsTile from '../components/feature/cancelroadsideform/steps/shared/ProductDetailsTile';
import Step1CancelRoadside from '../components/feature/cancelroadsideform/steps/Step1CancelRoadside';
import Step2CancelRoadside from '../components/feature/cancelroadsideform/steps/Step2CancelRoadside';
import Step3CancelRoadside from '../components/feature/cancelroadsideform/steps/Step3CancelRoadside';
import CycloneInsuranceForm from '../components/feature/cycloneinsuranceform/CycloneInsuranceForm';
import SummaryPanel from '../components/feature/cycloneinsuranceform/steps/shared/SummaryPanel';
import Step1CycloneInsurance from '../components/feature/cycloneinsuranceform/steps/Step1CycloneInsurance';
import Step2CycloneInsurance from '../components/feature/cycloneinsuranceform/steps/Step2CycloneInsurance';
import Step3CycloneInsurance from '../components/feature/cycloneinsuranceform/steps/Step3CycloneInsurance';
import Step4CycloneInsurance from '../components/feature/cycloneinsuranceform/steps/Step4CycloneInsurance';
import Step5CycloneInsurance from '../components/feature/cycloneinsuranceform/steps/Step5CycloneInsurance';
import Footer from '../components/feature/footer/Footer';
import Header from '../components/feature/header/Header';
import LinkList from '../components/feature/linklist/LinkList';
import LiveChat from '../components/feature/livechat/LiveChat';
import NewMotorInsuranceForm from '../components/feature/newmotorinsuranceform/NewMotorInsuranceForm';
import ConfirmDialog from '../components/feature/newmotorinsuranceform/shared/ConfirmDialog';
import CustomCheckboxInput from '../components/feature/newmotorinsuranceform/shared/CustomCheckboxInput';
import CustomRadioInput from '../components/feature/newmotorinsuranceform/shared/CustomRadioInput';
import GenericStep from '../components/feature/newmotorinsuranceform/shared/GenericStep';
import MotorInsuranceJeopardy from '../components/feature/newmotorinsuranceform/shared/MotorInsuranceJeopardy';
import MotorInsuranceQuoteStep from '../components/feature/newmotorinsuranceform/shared/MotorInsuranceQuoteStep';
import MotorInsuranceQuoteStepTracker from '../components/feature/newmotorinsuranceform/shared/MotorInsuranceQuoteStepTracker';
import MotorInsuranceRacqForm from '../components/feature/newmotorinsuranceform/shared/MotorInsuranceRacqForm';
import PolicyDiscounts from '../components/feature/newmotorinsuranceform/shared/PolicyDiscounts';
import PolicySummary from '../components/feature/newmotorinsuranceform/shared/PolicySummary';
import RepeatableAtFaultClaims from '../components/feature/newmotorinsuranceform/shared/RepeatableAtFaultClaims';
import RepeatableOccurrenceInputGroup from '../components/feature/newmotorinsuranceform/shared/RepeatableOccurrenceInputGroup';
import RepeatableOccurrenceRadioGroup from '../components/feature/newmotorinsuranceform/shared/RepeatableOccurrenceRadioGroup';
import ReviewPremiumHeader from '../components/feature/newmotorinsuranceform/shared/ReviewPremiumHeader';
import StepFooter from '../components/feature/newmotorinsuranceform/shared/StepFooter';
import TitleFirstLastName from '../components/feature/newmotorinsuranceform/shared/TitleFirstLastName';
import ChangeEffectiveStartDate from '../components/feature/newmotorinsuranceform/steps/preliminary/ChangeEffectiveStartDate';
import GeneralConditions from '../components/feature/newmotorinsuranceform/steps/preliminary/GeneralConditions';
import PolicySelectList from '../components/feature/newmotorinsuranceform/steps/preliminary/PolicySelectList';
import SelectYourPolicy from '../components/feature/newmotorinsuranceform/steps/preliminary/SelectYourPolicy';
import AddExistingPrimaryDriver from '../components/feature/newmotorinsuranceform/steps/quote/add-primary-driver/AddExistingPrimaryDriver';
import AddPrimaryDriver from '../components/feature/newmotorinsuranceform/steps/quote/add-primary-driver/AddPrimaryDriver';
import PrimaryDriverDetails from '../components/feature/newmotorinsuranceform/steps/quote/add-primary-driver/PrimaryDriverDetails';
import AdditionalDriverInfo from '../components/feature/newmotorinsuranceform/steps/quote/additional-drivers/AdditionalDriverInfo';
import AdditionalDrivers from '../components/feature/newmotorinsuranceform/steps/quote/additional-drivers/AdditionalDrivers';
import NewAdditionalDriver from '../components/feature/newmotorinsuranceform/steps/quote/additional-drivers/NewAdditionalDriver';
import AddAccessoriesInput from '../components/feature/newmotorinsuranceform/steps/quote/car-details/AddAccessoriesInput';
import CarDetails from '../components/feature/newmotorinsuranceform/steps/quote/car-details/CarDetails';
import ConfirmationForm from '../components/feature/newmotorinsuranceform/steps/quote/confirmation/ConfirmationForm';
import ExcessAndSumInsured from '../components/feature/newmotorinsuranceform/steps/quote/excess-and-sum-insured/ExcessAndSumInsured';
import ExcessAndSumInsuredFormFields from '../components/feature/newmotorinsuranceform/steps/quote/excess-and-sum-insured/ExcessAndSumInsuredFormFields';
import ExcessDetails from '../components/feature/newmotorinsuranceform/steps/quote/excess-and-sum-insured/ExcessDetails';
import LowVehicleValueWarning from '../components/feature/newmotorinsuranceform/steps/quote/excess-and-sum-insured/LowVehicleValueWarning';
import CarFoundBox from '../components/feature/newmotorinsuranceform/steps/quote/find-your-car/CarFoundBox';
import FindYourCar from '../components/feature/newmotorinsuranceform/steps/quote/find-your-car/FindYourCar';
import FatZebraIframe from '../components/feature/newmotorinsuranceform/steps/quote/payment/FatZebraIframe';
import FatZebraPayment from '../components/feature/newmotorinsuranceform/steps/quote/payment/FatZebraPayment';
import PaymentForm from '../components/feature/newmotorinsuranceform/steps/quote/payment/PaymentForm';
import ReviewQuote from '../components/feature/newmotorinsuranceform/steps/quote/review/ReviewQuote';
import StepsContainer from '../components/feature/newmotorinsuranceform/steps/quote/StepsContainer';
import RenewalOfferForm from '../components/feature/renewalofferform/RenewalOfferForm';
import Step1RenewalOfferForm from '../components/feature/renewalofferform/steps/Step1RenewalOfferForm';
import Step2RenewalOfferForm from '../components/feature/renewalofferform/steps/Step2RenewalOfferForm';
import Step3RenewalOfferForm from '../components/feature/renewalofferform/steps/Step3RenewalOfferForm';
import ContentBlock from '../components/foundation/content/ContentBlock';
import PageContent from '../components/foundation/content/PageContent';
import FormulateTooltip from '../components/foundation/forms/controls/FormulateTooltip';
import FormulateVueSelect from '../components/foundation/forms/controls/FormulateVueSelect';
import RacqFormDatepicker from '../components/foundation/forms/controls/RacqFormDatepicker';
import RacqFormTooltip from '../components/foundation/forms/controls/RacqFormTooltip';
import RacqFormulateButtonGroup from '../components/foundation/forms/controls/RacqFormulateButtonGroup';
import racqFormulateInput from '../components/foundation/forms/controls/racqFormulateInput';
import RacqFormulateRangeInput from '../components/foundation/forms/controls/RacqFormulateRangeInput';
import RacqSelectFormulateInput from '../components/foundation/forms/controls/RacqSelectFormulateInput';
import DollarAmount from '../components/foundation/forms/DollarAmount';
import FormDisclaimer from '../components/foundation/forms/FormDisclaimer';
import FullScreenSpinner from '../components/foundation/forms/FullScreenSpinner';
import Jeopardy from '../components/foundation/forms/Jeopardy';
import JeopardyV2 from '../components/foundation/forms/JeopardyV2';
import Loader from '../components/foundation/forms/Loader';
import LoadingMask from '../components/foundation/forms/LoadingMask';
import ProductTile from '../components/foundation/forms/ProductTile';
import RACQForm from '../components/foundation/forms/RACQForm';
import RACQFormStep from '../components/foundation/forms/RACQFormStep';
import StepTitle from '../components/foundation/forms/StepTitle';
import StepTracker from '../components/foundation/forms/StepTracker';

const components = new Map();
components.set('Login', Login);
components.set('AddToCoverForm', AddToCoverForm);
components.set('DiscardModal', DiscardModal);
components.set('OptionalBenefits', OptionalBenefits);
components.set('RacqCheckBox', RacqCheckBox);
components.set('SummaryTable', SummaryTable);
components.set('Step1AddToCoverForm', Step1AddToCoverForm);
components.set('Step2AddToCoverForm', Step2AddToCoverForm);
components.set('Step3AddToCoverForm', Step3AddToCoverForm);
components.set('PageAnalyticsData', PageAnalyticsData);
components.set('CallBackForm', CallBackForm);
components.set('Step1CallBackForm', Step1CallBackForm);
components.set('Step2CallBackForm', Step2CallBackForm);
components.set('CancelInsuranceForm', CancelInsuranceForm);
components.set('ChangeVehicleTileInsurance', ChangeVehicleTileInsurance);
components.set('Step1CancelInsurance', Step1CancelInsurance);
components.set('Step2CancelInsurance', Step2CancelInsurance);
components.set('Step3CancelInsurance', Step3CancelInsurance);
components.set('Step4CancelInsurance', Step4CancelInsurance);
components.set('Step5CancelInsurance', Step5CancelInsurance);
components.set('CancelRoadsideForm', CancelRoadsideForm);
components.set('ChangeVehicleTile', ChangeVehicleTile);
components.set('ProductDetailsTile', ProductDetailsTile);
components.set('Step1CancelRoadside', Step1CancelRoadside);
components.set('Step2CancelRoadside', Step2CancelRoadside);
components.set('Step3CancelRoadside', Step3CancelRoadside);
components.set('CycloneInsuranceForm', CycloneInsuranceForm);
components.set('SummaryPanel', SummaryPanel);
components.set('Step1CycloneInsurance', Step1CycloneInsurance);
components.set('Step2CycloneInsurance', Step2CycloneInsurance);
components.set('Step3CycloneInsurance', Step3CycloneInsurance);
components.set('Step4CycloneInsurance', Step4CycloneInsurance);
components.set('Step5CycloneInsurance', Step5CycloneInsurance);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('LinkList', LinkList);
components.set('LiveChat', LiveChat);
components.set('NewMotorInsuranceForm', NewMotorInsuranceForm);
components.set('ConfirmDialog', ConfirmDialog);
components.set('CustomCheckboxInput', CustomCheckboxInput);
components.set('CustomRadioInput', CustomRadioInput);
components.set('GenericStep', GenericStep);
components.set('MotorInsuranceJeopardy', MotorInsuranceJeopardy);
components.set('MotorInsuranceQuoteStep', MotorInsuranceQuoteStep);
components.set('MotorInsuranceQuoteStepTracker', MotorInsuranceQuoteStepTracker);
components.set('MotorInsuranceRacqForm', MotorInsuranceRacqForm);
components.set('PolicyDiscounts', PolicyDiscounts);
components.set('PolicySummary', PolicySummary);
components.set('RepeatableAtFaultClaims', RepeatableAtFaultClaims);
components.set('RepeatableOccurrenceInputGroup', RepeatableOccurrenceInputGroup);
components.set('RepeatableOccurrenceRadioGroup', RepeatableOccurrenceRadioGroup);
components.set('ReviewPremiumHeader', ReviewPremiumHeader);
components.set('StepFooter', StepFooter);
components.set('TitleFirstLastName', TitleFirstLastName);
components.set('ChangeEffectiveStartDate', ChangeEffectiveStartDate);
components.set('GeneralConditions', GeneralConditions);
components.set('PolicySelectList', PolicySelectList);
components.set('SelectYourPolicy', SelectYourPolicy);
components.set('AddExistingPrimaryDriver', AddExistingPrimaryDriver);
components.set('AddPrimaryDriver', AddPrimaryDriver);
components.set('PrimaryDriverDetails', PrimaryDriverDetails);
components.set('AdditionalDriverInfo', AdditionalDriverInfo);
components.set('AdditionalDrivers', AdditionalDrivers);
components.set('NewAdditionalDriver', NewAdditionalDriver);
components.set('AddAccessoriesInput', AddAccessoriesInput);
components.set('CarDetails', CarDetails);
components.set('ConfirmationForm', ConfirmationForm);
components.set('ExcessAndSumInsured', ExcessAndSumInsured);
components.set('ExcessAndSumInsuredFormFields', ExcessAndSumInsuredFormFields);
components.set('ExcessDetails', ExcessDetails);
components.set('LowVehicleValueWarning', LowVehicleValueWarning);
components.set('CarFoundBox', CarFoundBox);
components.set('FindYourCar', FindYourCar);
components.set('FatZebraIframe', FatZebraIframe);
components.set('FatZebraPayment', FatZebraPayment);
components.set('PaymentForm', PaymentForm);
components.set('ReviewQuote', ReviewQuote);
components.set('StepsContainer', StepsContainer);
components.set('RenewalOfferForm', RenewalOfferForm);
components.set('Step1RenewalOfferForm', Step1RenewalOfferForm);
components.set('Step2RenewalOfferForm', Step2RenewalOfferForm);
components.set('Step3RenewalOfferForm', Step3RenewalOfferForm);
components.set('ContentBlock', ContentBlock);
components.set('PageContent', PageContent);
components.set('FormulateTooltip', FormulateTooltip);
components.set('FormulateVueSelect', FormulateVueSelect);
components.set('RacqFormDatepicker', RacqFormDatepicker);
components.set('RacqFormTooltip', RacqFormTooltip);
components.set('RacqFormulateButtonGroup', RacqFormulateButtonGroup);
components.set('racqFormulateInput', racqFormulateInput);
components.set('RacqFormulateRangeInput', RacqFormulateRangeInput);
components.set('RacqSelectFormulateInput', RacqSelectFormulateInput);
components.set('DollarAmount', DollarAmount);
components.set('FormDisclaimer', FormDisclaimer);
components.set('FullScreenSpinner', FullScreenSpinner);
components.set('Jeopardy', Jeopardy);
components.set('JeopardyV2', JeopardyV2);
components.set('Loader', Loader);
components.set('LoadingMask', LoadingMask);
components.set('ProductTile', ProductTile);
components.set('RACQForm', RACQForm);
components.set('RACQFormStep', RACQFormStep);
components.set('StepTitle', StepTitle);
components.set('StepTracker', StepTracker);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
